import type { DatePickerProps, DialogControlProps } from '@_/ui';
import { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { buttonCommonI18n } from '@_/i18n-common';
import { Button, DatePicker, withDialog, DialogFooter } from '@_/ui';

export type DatePickerDialogProps = DialogControlProps &
  Pick<
    DatePickerProps,
    'include' | 'maxDate' | 'minDate' | 'onChange' | 'ranged' | 'timezone' | 'value'
  >;

export const DatePickerDialog = withDialog(
  {
    showCloseButton: true
  },
  function DatePickerDialogContent({
    onAnimationEnd,
    onOpenChange,
    onChange,
    open,
    value,
    ...datePickerProps
  }: DatePickerDialogProps) {
    const [dates, setDates] = useState(value || null);

    useEffect(() => {
      setDates(value || null);
    }, [value]);

    return (
      <div className="flex size-full flex-col sm:pt-8">
        <div className="grow overflow-hidden">
          <DatePicker {...datePickerProps} onChange={setDates} value={dates} />
        </div>
        <DialogFooter sticky>
          <div className="flex flex-none items-center justify-between">
            <Button disabled={!dates?.length} onClick={() => setDates(null)} variant="subtle">
              <FormattedMessage {...buttonCommonI18n.clearDates} />
            </Button>

            <Button
              color="primary"
              onClick={() => {
                onChange?.(dates);
                onOpenChange(false);
              }}
            >
              <FormattedMessage {...buttonCommonI18n.save} />
            </Button>
          </div>
        </DialogFooter>
      </div>
    );
  }
);
